import { render } from "./authorizers.vue?vue&type=template&id=32efec7a"
import script from "./authorizers.vue?vue&type=script&lang=js"
export * from "./authorizers.vue?vue&type=script&lang=js"

import "./authorizers.vue?vue&type=style&index=0&id=32efec7a&lang=postcss"
script.render = render

export default script